import React, { useEffect } from 'react';
import { usePaystackPayment } from 'react-paystack';
import { doc, getDoc, updateDoc, increment, arrayUnion } from 'firebase/firestore';
import { firestore } from '../Firebase/Firebase'; // Adjust the import based on your project structure
import ReactGA from 'react-ga4'; // Make sure this is installed and initialized
import { Button } from 'react-bootstrap';

const PayWithPaystack = ({ user, selectedAsset, setHasPaid, setShowModal }) => {
    const transactionId = Date.now().toString();

    const config = {
        reference: transactionId,
        email: user?.email,
        amount: selectedAsset?.price * 100,
        publicKey: 'pk_live_9c10c0a334dc47d2936c17caeb23425f60c08456',
        currency: 'NGN',
    };

    const savePurchaseHistory = async (purchaseData) => {
        try {
            const userRef = doc(firestore, 'users', purchaseData?.userId);
            await updateDoc(userRef, {
                purchaseHistory: arrayUnion(purchaseData),
            });
        } catch (error) {
            console.error('Error saving purchase history:', error);
        }
    };

    const trackPurchase = (transactionId, items, totalValue) => {
        if (sessionStorage.getItem('purchaseTracked_' + transactionId)) return;
        sessionStorage.setItem('purchaseTracked_' + transactionId, 'true');

        ReactGA.event('purchase', {
            transaction_id: transactionId,
            value: parseFloat(totalValue),
            currency: 'NGN',
            items: items.map((item) => ({
                item_name: item.name,
                item_id: item.id,
                price: parseFloat(item.price),
                quantity: item.quantity || 1,
                category: item.category || 'Uncategorized',
            })),
        });
    };

    const onSuccess = async (reference) => {
        console.log('✅ Payment successful:', reference);

        try {
            const assetRef = doc(firestore, 'Assets', selectedAsset?.id);
            const assetDoc = await getDoc(assetRef);

            if (assetDoc.exists()) {
                const data = assetDoc.data();
                console.log("🔍 Asset data before update:", data);

                await updateDoc(assetRef, {
                    downloads: increment(1),
                });

                console.log("✅ Download count incremented");

                const purchaseData = {
                    itemName: selectedAsset.name,
                    date: new Date().toISOString(),
                    amount: selectedAsset.price,
                    userId: user.uid,
                    thumbnail: selectedAsset.thumbnail,
                    transactionId: reference.reference,
                    downloadUrl: selectedAsset.asset,
                    assetId: selectedAsset.id,
                    expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
                };

                await savePurchaseHistory(purchaseData);
                trackPurchase(reference.reference, [selectedAsset], selectedAsset.price);

                // Save locally for 2 hours
                const expiresAt = Date.now() + 2 * 60 * 60 * 1000;
                localStorage.setItem(
                    `paidAsset_${selectedAsset.id}`,
                    JSON.stringify({ paid: true, expiresAt })
                );

                setHasPaid(true);
                setShowModal(false);

                // Trigger download (force download instead of opening in browser)
                const a = document.createElement('a');
                a.href = selectedAsset.asset;
                a.download = ''; // Let browser decide filename
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                console.error('⚠️ Asset not found in database.');
                alert('Something went wrong: asset not found.');
            }
        } catch (error) {
            console.error('❌ Error in post-payment process:', error);
            alert('There was an error processing your download. Please contact support.');
        }
    };

    const onClose = () => {
        console.log('❌ Paystack dialog closed.');
        alert('Transaction was not completed.');
    };

    const initializePayment = usePaystackPayment(config);

    useEffect(() => {
        if (selectedAsset) {
            const stored = localStorage.getItem(`paidAsset_${selectedAsset.id}`);
            if (stored) {
                const { paid, expiresAt } = JSON.parse(stored);
                if (paid && Date.now() < expiresAt) {
                    setHasPaid(true);
                } else {
                    localStorage.removeItem(`paidAsset_${selectedAsset.id}`);
                    setHasPaid(false);
                }
            }
        }
    }, [selectedAsset, setHasPaid]);

    return (
        <Button variant="primary" className="learnBtn" onClick={() => initializePayment({onSuccess, onClose})}>
            Purchase Asset
        </Button>
    );
};

export default PayWithPaystack;
